import React, { useState, useEffect } from "react";
import moment from "moment";
import S3 from "aws-sdk/clients/s3";
import AWS from "aws-sdk/global";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import ImageSlide from "./ImageSlide";
import BackButton from "./BackButton";

const UploadView = (props) => {
  const [tab, setTab] = useState();
  // const [descr, setDescr] = useState("");
  // const [benname, setBenname] = useState("");
  const [finalimage, setFinalimanges] = useState([]);
  const [activeIndex, setActiveIndex] = useState("");
  const [slidepopup, setSlidepopup] = useState(false);
  const [imageArry, setImages] = useState(false);
  const [description, setDescription] = useState("");
  const [benName, setBenName] = useState("");


  useEffect(() => {
    $(".loader_bg").show();
    if (props.data && finalimage) {
      let imageArr = JSON.parse(props.data.images);
      // setBenname(props.data.beneficiary);
      // setDescr(props.data.description);
      setDescription(props.data.description)
      setBenName(props.data.beneficiary)
      setFinalimanges(imageArr);
    }
    $(".loader_bg").hide();
  }, []);

  const setImageslide = (images, index) => {
    if (index) {
      setActiveIndex(index);
    }
    setImages(images);
    setSlidepopup(true);
    $("body").css("overflow", "hidden");
  };

  const hideSlide = () => {
    setActiveIndex("");
    setSlidepopup(false);
    $("body").css("overflow", "auto");
  };

  const submit = () => {
    $(".loader_bg").show();
   // let msg = desc.current.value;
   let msg = description;
   // let beni = beneficiary.current.value;
   let beni = benName;

    if (msg && msg.length > 100) {
      $(".error_p_msg").text("Description must be less than 100 chars.");
      return false;
    } else {
      $(".error_p_msg").text("");
    }

    if (beni && beni.length > 50) {
      $(".error_p_msg_beni").text("Beneficiary Name must be less than 50 chars.");
      return false;
    } else {
      $(".error_p_msg_beni").text("");
    }

    let dataObj = {
      images: props.data.images,
      description: msg ? msg : "",
      beneficiary: beni ? beni : "",
    };
    props.getData(dataObj, "submit");
    // props.nextpage('checkin')
  };

  const queryString = window.location.search;

  var desc = React.useRef();
  var beneficiary = React.useRef();

  const closeUloadView = () => props.nextpage('checkin')

  return (
    <>
      <div className="smajik_bg">
        <div className="container">
          <BackButton close={closeUloadView} />
          <div className="smajik_banner">
            <img src="/assets/images/img-31.jpg" alt="" />
          </div>

          <div className="smajik_list">
            {/* <ul>
              <li className={tab == "popular" ? "active" : ""}>
                <NavLink to={"/" + queryString}>popular </NavLink>
              </li>
              <li className={tab == "gallery" ? "active" : ""}>
                <NavLink to={"/gallery" + queryString}>recent </NavLink>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
      <div className="upload_bg">
        <div className="container">
          <div className="uploadimg_div">
            <h5>Uploads</h5>
            {finalimage && (
              <ul className="upload_img_list">
                {finalimage && finalimage.length <= 4 ? (
                  finalimage &&
                  finalimage.map((image, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setImageslide(finalimage, index);
                      }}
                    >
                      <a>
                        <img
                          src={image.replace(
                            "https://campaign-images.narendramodi.in/",
                            "https://nm-seva-photos.b-cdn.net/"
                          ) + '?class=preview'}
                          alt=""
                        />
                      </a>
                      {/* <span className="cross_tag">
                        <img src="/assets/images/crosscircle.svg" alt="" />
                      </span> */}
                    </li>
                  ))
                ) : (
                  <>
                    {finalimage.map((image, index) => {
                      if (index < 3) {
                        return (
                          <li
                            key={index}
                            onClick={() => {
                              setImageslide(finalimage, index);
                            }}
                          >
                            <a>
                              <img
                                src={image.replace(
                                  "https://campaign-images.narendramodi.in/",
                                  "https://nm-seva-photos.b-cdn.net/"
                                )}
                                alt=""
                              />
                            </a>
                            {/* <span className="cross_tag">
                              <img src="/assets/images/crosscircle.svg" alt="" />
                            </span> */}
                          </li>
                        );
                      }
                    })}
                    <li
                      onClick={() => {
                        setImageslide(finalimage);
                      }}
                    >
                      <a>
                        <div className="overlay_div_view">
                          <img src={finalimage[3]} alt="" />
                          <div className="overlay"></div>
                          <h3>+{finalimage.length - 4}</h3>
                        </div>
                      </a>
                    </li>
                  </>
                )}
              </ul>
            )}
          </div>

          <div className="desc_detail">
            <h5>Description</h5>
            <textarea
              maxLength={100}
              // defaultValue={descr ? descr : ""}
              // ref={desc}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                if (e.target.value.length < 101) {
                  $(".error_p_msg").text("");
                } else {
                  $(".error_p_msg").text(
                    "Description length must be less than 100 chars."
                  );
                }
              }}
              placeholder="Describe your memorable experience with the beneficiary…."
            />
            <p className="error_p error_p_msg"></p>
          </div>
          <div className="desc_detail">
            <h5>Beneficiary Name</h5>
            <input
              // defaultValue={benname ? benname : ""}
              // ref={beneficiary}
              value={benName}
              onChange={(e) => {
                setBenName(e.target.value);
                if (e.target.value.length < 51) {
                  $(".error_p_msg_beni").text("");
                } else {
                  $(".error_p_msg_beni").text(
                    "Beneficiary name must be less than 50 chars."
                  );
                }
              }}
              maxLength={50}
              type="text"
              placeholder="Beneficiary Name"
            />
            <p className="error_p error_p_beni"></p>
          </div>
          <div className="next_btn">
            <a
              href="#"
              onClick={() => {
                submit();
              }}
            >
              Submit
            </a>
          </div>
        </div>
      </div>
      {slidepopup && (
        <ImageSlide
          images={imageArry}
          activeIndex={activeIndex}
          hideSlide={hideSlide}
        />
      )}
    </>
  );
};

export default UploadView;
